import { makeStyles } from '@material-ui/core';


export const docuSignStyles = makeStyles(() => ({
    docusignContanier: {
        width: '100%',
        minHeight: '75vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    docusignAgreement: {
        width: '100%',
        height: '75vh',
    },
}));



